module.exports = __webpack_public_path__ + "img/go.018124f1.png";